import { Fragment } from 'react'
import styled from 'styled-components'

import { Type } from '../elements/Typography/Typography'
import { ArrowLink } from './ArrowLink'

const LinksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 0 1rem;
`

export const HelpfulLinks = ({ title, links }) => (
  <Fragment>
    {title && (
      <Type preset="label" bottom={{ xs: 0.5, md: 1 }}>
        {title}
      </Type>
    )}
    <LinksGrid>
      {links.map(link => (
        <ArrowLink key={link.fields.url} to={link.fields.url}>
          {link.fields.label}
        </ArrowLink>
      ))}
    </LinksGrid>
  </Fragment>
)
